import React, { useMemo } from "react";

export default function EmailSandbox({ html = "", baseUrl }) {
  const safeHtml = typeof html === "string" ? html : String(html || "");

  const isFullDoc = useMemo(
    () => /<!doctype\s+html/i.test(safeHtml) || /<\s*html[\s>]/i.test(safeHtml),
    [safeHtml]
  );

  const srcDoc = useMemo(() => {
    if (!safeHtml) {
      return `<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<base href="${baseUrl || "/"}" target="_blank">
<style>html,body{margin:0;padding:0}</style>
</head>
<body></body>
</html>`;
    }

    if (isFullDoc) {
      let out = safeHtml;

      if (/<\s*head[\s>]/i.test(out)) {
        out = out.replace(
          /<\s*head([^>]*)>/i,
          `<head$1><base href="${
            baseUrl || "/"
          }" target="_blank"><style>html,body{margin:0;padding:0}</style>`
        );
      } else if (/<\s*html([^>]*)>/i.test(out)) {
        out = out.replace(
          /<\s*html([^>]*)>/i,
          `<html$1><head><base href="${
            baseUrl || "/"
          }" target="_blank"><style>html,body{margin:0;padding:0}</style></head>`
        );
      } else {
        out = `<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<base href="${baseUrl || "/"}" target="_blank">
<style>html,body{margin:0;padding:0}</style>
</head>
<body>${safeHtml}</body>
</html>`;
      }

      return out;
    }

    return `<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<base href="${baseUrl || "/"}" target="_blank">
<style>html,body{margin:0;padding:0}</style>
</head>
<body>${safeHtml}</body>
</html>`;
  }, [safeHtml, baseUrl, isFullDoc]);

  return (
    <iframe
      key={`${isFullDoc}-${safeHtml.length}-${safeHtml.slice(0, 80)}`}
      title="Email"
      srcDoc={srcDoc}
      sandbox="allow-popups allow-top-navigation-by-user-activation"
      referrerPolicy="no-referrer"
      style={{
        width: "100%",
        height: "100%",
        border: 0,
        display: "block",
        background: "#fff",
      }}
    />
  );
}
